import asyncComponent from "./asyncComponent";
const _import_views = (file) => asyncComponent(() => import(`../pages${file}`));
export default [
  {
    title: "来源统计",
    path: "/home",
    exact: true,
    component: _import_views("/home/index"),
  },
  {
    title: "候选球员",
    path: "/playerManagement",
    exact: true,
    component: _import_views("/playerManagement/index"),
  },
  {
    title: "名人堂入选",
    path: "/hallFameCandidate",
    exact: true,
    component: _import_views("/hallFameCandidate/index"),
  },
  {
    title: "球员添加",
    path: "/addPlayer",
    exact: true,
    hidden: true,
    component: _import_views("/playerManagement/addPlayer"),
  },
  {
    title: "球员编辑",
    path: "/addPlayer/:id",
    exact: true,
    hidden: true,
    component: _import_views("/playerManagement/addPlayer"),
  },
  {
    title: "用户管理",
    path: "/userList",
    exact: true,
    component: _import_views("/userList/index"),
  },
  {
    title: "内容管理",
    path: "/content",
    exact: true,
    children: [
      {
        title: "活动规则",
        path: "/activeRule",
        exact: true,
        component: _import_views("/content/activeRule"),
      },
      {
        title: "相关条款",
        path: "/relateRule",
        exact: true,
        component: _import_views("/content/relateRule"),
      },
    ],
  },
  {
    title: "投票列表",
    path: "/voteList",
    exact: true,
    component: _import_views("/voteList/index"),
  },
  {
    title: "渠道管理",
    path: "/channelList",
    exact: true,
    component: _import_views("/channelList/index"),
  },
  {
    title: "活动首页管理",
    path: "/activeIndex",
    exact: true,
    component: _import_views("/activeIndex/index"),
  },
];



// WEBPACK FOOTER //
// ./src/router/routerConfig.js